import Vue from 'vue'
import LazyLoadDirective from '~/directives/LazyLoadDiractive'

Vue.directive('lazyload', LazyLoadDirective)
